import { defineMessages } from 'react-intl';

export default defineMessages({

    additionalInterest: {
        id: 'quoteandbind.residential.additionalInfo.Additional Interests',
        defaultMessage: 'Additional Interests',
    },
    additionalInsured: {
        id: 'quoteandbind.residential.additionalInfo.Additional Named Insureds',
        defaultMessage: 'Additional Named Insureds',
    },
    

});
